import actions from "./actions";
import generatorService from "../../../common/services/generator-service";

const getGeneratedImages = (amount, category) => async (dispatch) => {
  dispatch(actions.getGeneratedImagesStarted());
  try {
    const response = await generatorService.getSpecifiedAmountOfImages({
      amount,
      category,
    });
    window.analytics.track("Generated new images", {
      generatorType: category,
      device: "mobile",
    });
    dispatch(actions.getGeneratedImagesSuccess(response.data));
  } catch (error) {
    window.analytics.track("Error Log", {
      category: "Generator",
      generatorType: category,
      device: "mobile",
      error: error,
    });
    dispatch(actions.getGeneratedImagesError(error));
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getGeneratedImages,
};
